var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import propTypes from 'prop-types';
import { Link } from '@wikom/wikom-router';
import AreaAwareItem from './AreaAwareItem';
export var NavItem = function (_a) {
    var user = _a.user, rest = __rest(_a, ["user"]);
    var element = null;
    var linkProps = {};
    if (rest.hasOwnProperty('target')) {
        linkProps.target = rest.target;
    }
    if (rest.hasOwnProperty('to')) {
        element = React.createElement("li", null,
            React.createElement(Link, __assign({ to: rest.to }, linkProps), rest.children));
    }
    else if (rest.hasOwnProperty('href')) {
        element = React.createElement("li", null,
            React.createElement("a", __assign({ href: rest.href }, linkProps), rest.children));
    }
    if (rest.hasOwnProperty('area')) {
        return (React.createElement(AreaAwareItem, __assign({ user: user }, rest), element));
    }
    else {
        return element;
    }
};
NavItem.propTypes = {
    user: propTypes.object.isRequired,
    children: propTypes.node.isRequired,
    to: propTypes.string,
    href: function (props, key, componentName) {
        if (!props.hasOwnProperty('href')) {
            if (!props.hasOwnProperty('to')) {
                return new Error("One of props 'to' or 'href' was not specified in '".concat(componentName, "'."));
            }
        }
        else {
            if (!(props.href instanceof String || typeof props.href === 'string')) {
                return new Error("'href' must be string in '".concat(componentName, "'."));
            }
        }
    }
};
var NavItemFactory = function (user) { return (function (_a) {
    var rest = __rest(_a, []);
    return React.createElement(NavItem, __assign({}, rest, { user: user }));
}); };
NavItemFactory.propTypes = {
    user: propTypes.object.isRequired,
};
export default NavItemFactory;
